export const clearToc = (tocElement, isMobile) => {
	if (isMobile) {
		const selectElement = tocElement.querySelector('select');
		if (selectElement) {
			selectElement.innerHTML = '';
		}
		return;
	}

	tocElement.innerHTML = '';
};

export const buildDesktopToc = (filteredHeadlines, tocElement) => {
	const minLevel = Math.min(...filteredHeadlines.map((heading) => heading.level));
	let toc = '';
	let previousLevel = 0;

	filteredHeadlines.forEach((heading) => {
		const { level: headingLevel, text: headerText, anchor } = heading;
		const depth = headingLevel - minLevel + 1;

		if (previousLevel === 0) {
			toc += `<ul class="lvl-${depth}"><li><a class="no-link" href="#${anchor}">${headerText}</a>`;
		} else if (headingLevel > previousLevel) {
			const levelDiff = headingLevel - previousLevel;
			for (let j = 0; j < levelDiff; j++) {
				toc += `<ul class="lvl-${depth - levelDiff + j + 1}">`;
			}
			toc += `<li><a class="no-link" href="#${anchor}">${headerText}</a>`;
		} else if (headingLevel < previousLevel) {
			const levelDiff = previousLevel - headingLevel;
			toc += '</li>';
			for (let j = 0; j < levelDiff; j++) {
				toc += '</ul></li>';
			}
			toc += `<li><a class="no-link" href="#${anchor}">${headerText}</a>`;
		} else {
			toc += `</li><li><a class="no-link" href="#${anchor}">${headerText}</a>`;
		}

		previousLevel = headingLevel;
	});

	if (previousLevel > 0) {
		toc += '</li>';
		const minListLevel = Math.min(...filteredHeadlines.map((heading) => heading.level));
		const remainingLevels = previousLevel - minListLevel;
		for (let j = 0; j < remainingLevels; j++) {
			toc += '</ul></li>';
		}
		toc += '</ul>';
	}

	tocElement.innerHTML = toc;
};

export const buildMobileToc = (filteredHeadlines, tocElement) => {
	let toc = '';

	filteredHeadlines.forEach((heading) => {
		const { text: headerText, anchor } = heading;
		toc += `<option value="#${anchor}">${headerText}</option>`;
	});

	const selectElement = tocElement.querySelector('select');
	if (selectElement) {
		selectElement.innerHTML = toc;
	}
};
